import React from 'react';
import {IconItemTemplate, Select, Separator} from '@priority-software/priority-style-react';
import {Operator} from '@priority-software/priority-utils/lib/operators';
import {getLocalizedText} from '../../../../constants/TextConst';
import styles from './styles.module.scss';
import {ISearchCondition} from '../../types/filters';
import {ColumnTypeOptions, OperatorIconMapping, ZoomOperatorOptions} from '../../types/operator';
import {ColumnType} from '../../types/column';
import {ISearchField} from '../../../../common/searchType';

interface Props {
    filter: ISearchCondition;
    column: ISearchField;
    onChangeOperator: (Operator: Operator) => void;
}

const Operators = ({filter, column, onChangeOperator}: Props) => {
    const {operator, type} = filter;
    const selected = OperatorIconMapping[operator ?? Operator.Equals];
    const operators =
        column.isZoom && type === ColumnType.Text ? ZoomOperatorOptions : ColumnTypeOptions[type];
    const options = operators?.map(op => ({
        value: op,
        label: getLocalizedText(OperatorIconMapping[op]?.name),
        icon: OperatorIconMapping[op]?.icon
    }));

    const value = {
        value: operator,
        label: getLocalizedText(selected?.name),
        icon: selected?.icon
    };

    const Item = (data, isSelected) => {
        if (data.value === Operator.Empty) {
            return (
                <>
                    <Separator align="vertical" height={1} componentClasses={styles.separator} />
                    {IconItemTemplate(data, isSelected)}
                </>
            );
        } else {
            return IconItemTemplate(data, isSelected);
        }
    };

    return (
        <Select
            size="medium"
            options={options}
            onChange={op => onChangeOperator(op.value)}
            value={value}
            renderItem={Item}
            isOptionDisabled={option => option.disabled}
            componentClasses={styles.operators}
            isSearchable={false}
            placeholder={<></>}
        />
    );
};

export default Operators;
